import { useEffect } from 'react';
import PropTypes from 'prop-types';
import fromTherapy from './fromTherapy';

export default ComposedComponent => {
  function SessionWrapper(props) {
    useEffect(() => {
      if (props.match.params.token) {
        fromTherapy(props);
      }
      // Match class componentDidMount: run once on mount only.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <ComposedComponent {...props} />;
  }

  SessionWrapper.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  return SessionWrapper;
};
